
// import { BrokenUserIcon, BrokenUserTickIcon, AdminUsersIcon } from "../../../assets/Icons";

export const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
};
